export default __webpack_public_path__ + "static/media/chest.b52c9de1.svg";